import { useGoogleAnalytics } from '@hotmart/space-lib/dist/hooks'
import { useUser } from 'src/hook/useUser'
import useSendDataHubConsume from 'src/hook/useSendDatahubConsume/useSendDatahubConsume'
import { Actions, ComponentNames, Entities, EventNames, ScreenNames } from 'src/utils/datahub/enums'
import { useOptimizely } from 'src/hook/useOptimizely'
import { CommentType } from 'src/components/postComments'

function useDispatchEvents() {
  const { locale, user } = useUser()
  const { sendDataHubConsume } = useSendDataHubConsume()
  const { optimizely } = useOptimizely()
  const { sendGoogleAnalyticsEvent } = useGoogleAnalytics({
    userId: user?.id,
    locale
  })

  const sendOpenActionsEvent = () => {
    sendDataHubConsume({
      action: Actions.VIEW,
      entity: Entities.COMMUNITY,
      event: {
        eventName: EventNames.CLICK_TO_START_A_COMMENT,
        screenName: ScreenNames.COMMUNITY_POST_COMMENT,
        componentName: ComponentNames.INPUT_COMMENT
      }
    })

    sendGoogleAnalyticsEvent({
      group: Entities.GENERIC,
      name: Actions.CREATE
    })
  }

  const sendCreateCommentEvent = () => {
    sendDataHubConsume({
      action: Actions.VIEW,
      entity: Entities.COMMUNITY,
      event: {
        eventName: EventNames.TRY_TO_POST_A_COMMENT,
        screenName: ScreenNames.NORMAL_POST,
        componentName: ComponentNames.INPUT_COMMENT,
        arrivedFrom: ScreenNames.COMMUNITY_NEW_FEED
      }
    })

    optimizely.push({
      type: 'event',
      eventName: EventNames.TRY_TO_POST_A_COMMENT,
      tags: {
        action: Actions.VIEW,
        entity: Entities.COMMUNITY,
        screenName: ScreenNames.NORMAL_POST,
        componentName: ComponentNames.INPUT_COMMENT,
        arrivedFrom: ScreenNames.COMMUNITY_NEW_FEED
      }
    })

    optimizely.track(EventNames.TRY_TO_POST_A_COMMENT)
  }

  const sendMediaEvent = (mediaType: CommentType) => {
    const eventNames = {
      [CommentType.AUDIO]: EventNames.CLICK_TO_START_AUDIO_RECORDING,
      [CommentType.IMAGE]: EventNames.CLICK_TO_UPLOAD_IMAGE_ON_COMMENT,
      [CommentType.DOCUMENT]: EventNames.CLICK_TO_UPLOAD_PDF_ON_COMMENT
    }

    const eventName = eventNames[mediaType]

    sendDataHubConsume({
      action: Actions.VIEW,
      entity: Entities.COMMUNITY,
      event: {
        eventName,
        screenName: ScreenNames.COMMUNITY_POST_COMMENT,
        componentName: ComponentNames.INPUT_COMMENT
      }
    })
  }

  return {
    sendOpenActionsEvent,
    sendCreateCommentEvent,
    sendMediaEvent
  }
}

export default useDispatchEvents
